import type { AppDefinition } from '../types';
import type { SubstantivoPayload } from '../generos/types';
import { CardFront } from './CardFront';

/**
 * Substantivos — what the word means.
 *
 * The mirror of Nouns, and the sibling of Gêneros, which asks the same word's
 * article. One list, two decks, separate progress: knowing that `mão` means
 * hand and knowing it takes `a` are learned at different speeds, and a single
 * card that asks both teaches neither reliably. That split has been the shape
 * of the German side since the first migration.
 *
 * No CardBack or MissRow of its own — the shared translation views already fit,
 * because the answer here is a short gloss, which is exactly what they were
 * built for.
 */
export const substantivosApp: AppDefinition<SubstantivoPayload> = {
  id: 'substantivos',
  display_name: 'Substantivos',
  CardFront,
};
